import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { supabase } from '../supabaseClient';
import Header from '../components/Header';
import ChecklistRunner from '../components/ChecklistRunner';
import { getBuiltinTemplate, BUILTIN_TEMPLATES } from '../data/builtinTemplates';
import { useOrg } from '../contexts/OrgContext';

const BUILTIN_TYPES = Object.keys(BUILTIN_TEMPLATES);

export default function ChecklistPage() {
  const { type } = useParams();
  const navigate = useNavigate();
  const { membership } = useOrg();
  const [template, setTemplate] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    if (BUILTIN_TYPES.includes(type)) {
      const t = getBuiltinTemplate(type);
      setTemplate(t);
      setLoading(false);
      return;
    }

    // Treat as custom template UUID
    const cacheKey = `gc_template_${type}`;
    const primed = (() => { try { return JSON.parse(localStorage.getItem(cacheKey)); } catch { return null; } })();
    if (primed) {
      setTemplate(primed);
      setLoading(false);
    }
    supabase
      .from('checklist_templates')
      .select('id, name, type, items')
      .eq('id', type)
      .eq('org_id', membership?.org_id)
      .single()
      .then(({ data, error }) => {
        if (data && !error) {
          const t = { id: data.id, name: data.name, type: data.type, sections: data.items };
          setTemplate(t);
          try { localStorage.setItem(cacheKey, JSON.stringify(t)); } catch {}
          setLoading(false);
        } else if (!primed) {
          setNotFound(true);
          setLoading(false);
        }
        // primed && fetch failed: template already showing, leave state alone
      });
  }, [type, membership?.org_id]);

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-900 flex items-center justify-center">
        <div className="text-orange-500 animate-pulse">Loading…</div>
      </div>
    );
  }

  if (notFound || !template) {
    return (
      <div className="min-h-screen bg-gray-900 flex items-center justify-center px-4">
        <div className="text-center">
          <p className="text-red-400 font-semibold mb-2">Checklist not found</p>
          <button onClick={() => navigate('/dashboard')} className="text-orange-400 text-sm">
            Back to dashboard
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-900">
      <Header title={template.name} backTo="/dashboard" />
      <ChecklistRunner
        sections={template.sections}
        templateName={template.name}
        checklistType={template.type}
        templateId={BUILTIN_TYPES.includes(type) ? null : template.id}
      />
    </div>
  );
}
